{
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.admin-key": [
    {
      "children": [
        {
          "type": 0,
          "value": "Admin key"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Access restricted content so you can fix issues"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.advanced-insights": [
    {
      "children": [
        {
          "type": 0,
          "value": "Advanced insights"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Audit and track all admin activity"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.support": [
    {
      "children": [
        {
          "type": 0,
          "value": "24/7 support"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Dedicated support team for critical issues"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try the 'Mission Control' feature on the Premium plan. This will give them a dashboard to easily see activity across spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try the 'Mission Control' feature on the Confluence Premium plan. This will give them a dashboard to easily see activity across spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Mission Control'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.title": [
    {
      "type": 0,
      "value": "Help your team do more and worry less"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try 'Mission Control'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " stay across team activity"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-features-title": [
    {
      "type": 0,
      "value": "You also get more admin features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try advanced page elements"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.title": [
    {
      "type": 0,
      "value": "Help your team create engaging content"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced page elements"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " create engaging content"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try advanced permissions features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.title": [
    {
      "type": 0,
      "value": "Help your team manage access better"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try 'advanced permissions features'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " manage access better"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try the 'Company Hub' feature on the Premium plan. This will let them create a central place for updates and key resources."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try the ‘Company Hub’ feature on the Premium plan. This will let them create a central place for updates and key resources."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Company Hub'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.title": [
    {
      "type": 0,
      "value": "Give your team one place to share updates"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try 'Company Hub'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.title": [
    {
      "type": 0,
      "value": "Give "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " one place to share updates"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try the 'Content manager' feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try the ‘Content Manager’ feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Content manager'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.title": [
    {
      "type": 0,
      "value": "Help your team keep spaces organised"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try 'Content manager'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " keep spaces organised"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.body-description": [
    {
      "children": [
        {
          "type": 0,
          "value": "Let "
        },
        {
          "type": 1,
          "value": "firstName"
        },
        {
          "type": 0,
          "value": " try on a free, "
        },
        {
          "type": 1,
          "value": "trialLengthDays"
        },
        {
          "type": 0,
          "value": "-day trial."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Cancel anytime. We'll remind you "
    },
    {
      "type": 1,
      "value": "reminderDays"
    },
    {
      "type": 0,
      "value": " days before your trial ends."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " has requested to try features on the Confluence Premium plan."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.body-description": [
    {
      "children": [
        {
          "type": 0,
          "value": "Let your team member try on a free, "
        },
        {
          "type": 1,
          "value": "trialLengthDays"
        },
        {
          "type": 0,
          "value": "-day trial."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Cancel anytime. We'll remind you "
    },
    {
      "type": 1,
      "value": "reminderDays"
    },
    {
      "type": 0,
      "value": " days before your trial ends."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try features on the Confluence Premium plan."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try new features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.title": [
    {
      "type": 0,
      "value": "Unlock more insights, clarity, and speed for your team"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try new features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.title": [
    {
      "type": 0,
      "value": "Unlock more insights, clarity, and speed for "
    },
    {
      "type": 1,
      "value": "firstName"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.explore-all-features": [
    {
      "type": 0,
      "value": "Explore all features →"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.get-started-button": [
    {
      "type": 0,
      "value": "Get Started"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.img.alt": [
    {
      "type": 0,
      "value": "Confluence logo"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try advanced whiteboard features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.title": [
    {
      "type": 0,
      "value": "Boost your team's collaboration"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced whiteboard features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.title": [
    {
      "type": 0,
      "value": "Boost "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": "'s team collaboration"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.cta.permissions": [
    {
      "type": 0,
      "value": "Set up permissions"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.cta.plans": [
    {
      "type": 0,
      "value": "Create a plan"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.cta.rovo": [
    {
      "type": 0,
      "value": "Try Rovo AI"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.title.permissions": [
    {
      "type": 0,
      "value": "Keep work secure"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.title.plans": [
    {
      "type": 0,
      "value": "See all your timelines in one plan"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.title.rovo": [
    {
      "type": 0,
      "value": "Speed up your work"
    }
  ],
  "growth-luna.jira-recommend-retrial.permissions.allow-customer-submissions": [
    {
      "type": 0,
      "value": "Allow customers to submit bugs and requests"
    }
  ],
  "growth-luna.jira-recommend-retrial.permissions.assign-roles": [
    {
      "type": 0,
      "value": "Assign roles for groups, teams, or individuals"
    }
  ],
  "growth-luna.jira-recommend-retrial.permissions.set-custom-permissions": [
    {
      "type": 0,
      "value": "Set custom permissions for each role"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.cancel-anytime": [
    {
      "type": 0,
      "value": "Cancel anytime"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.customer-agreement": [
    {
      "type": 0,
      "value": "Atlassian Customer Agreement"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.progress-bar-label": [
    {
      "type": 0,
      "value": "Upgrading your workspace, less than a minute remaining..."
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.suggested-feature.permissions": [
    {
      "type": 0,
      "value": "Keep work secure and organized"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.suggested-feature.plans": [
    {
      "type": 0,
      "value": "See all your timelines in one plan"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.suggested-feature.rovo": [
    {
      "type": 0,
      "value": "Speed up your work with AI"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.terms": [
    {
      "type": 0,
      "value": "By continuing, you agree to the "
    },
    {
      "type": 1,
      "value": "customerAgreement"
    },
    {
      "type": 0,
      "value": " and acknowledge the "
    },
    {
      "type": 1,
      "value": "privacyPolicy"
    },
    {
      "type": 0,
      "value": ". "
    },
    {
      "type": 1,
      "value": "cancelAnytime"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.try-it-free": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.upgrading-message": [
    {
      "type": 0,
      "value": "Upgrading in a new tab, come back here when you're done..."
    }
  ],
  "growth-luna.jira-recommend-retrial.plans.break-into-steps": [
    {
      "type": 0,
      "value": "Break plans into achievable steps with AI"
    }
  ],
  "growth-luna.jira-recommend-retrial.plans.customize-view": [
    {
      "type": 0,
      "value": "Customize your view to suit you"
    }
  ],
  "growth-luna.jira-recommend-retrial.plans.team-progress": [
    {
      "type": 0,
      "value": "See every team's progress in one place"
    }
  ],
  "growth-luna.jira-recommend-retrial.rovo.get-quick-answers-and-smart-suggestions": [
    {
      "type": 0,
      "value": "Get quick answers and smart suggestions"
    }
  ],
  "growth-luna.jira-recommend-retrial.rovo.instantly-summarize-work-items-and-updates": [
    {
      "type": 0,
      "value": "Instantly summarize work items and updates"
    }
  ],
  "growth-luna.jira-recommend-retrial.rovo.turn-big-projects-into-easy-tasks": [
    {
      "type": 0,
      "value": "Instantly turn big projects into easy tasks"
    }
  ],
  "jira-recommend-retrial.placement.body.has-payment": [
    {
      "type": 0,
      "value": "Enjoy "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " days to try "
    },
    {
      "type": 1,
      "value": "suggestedFeature"
    },
    {
      "type": 0,
      "value": " with another free trial of "
    },
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Premium"
            }
          ]
        },
        "premium": {
          "value": [
            {
              "type": 0,
              "value": "Premium"
            }
          ]
        },
        "standard": {
          "value": [
            {
              "type": 0,
              "value": "Standard"
            }
          ]
        }
      },
      "type": 5,
      "value": "edition"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.ep-migration-inapp-715.body": [
    {
      "type": 0,
      "value": "Get Confluence Premium to ship projects faster with advanced admin controls and analytics."
    }
  ],
  "post-office.ep-migration-inapp-715.change-plans-button": [
    {
      "type": 0,
      "value": "Change plans"
    }
  ],
  "post-office.ep-migration-inapp-715.image-alt": [
    {
      "type": 0,
      "value": "Confluence Premium illustration"
    }
  ],
  "post-office.ep-migration-inapp-715.not-now-button": [
    {
      "type": 0,
      "value": "Not now"
    }
  ],
  "post-office.ep-migration-inapp-715.title": [
    {
      "type": 0,
      "value": "Grow more agile"
    }
  ],
  "post-office.jira-exp-banner.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ],
  "post-office.jira-standard-automation-limit-awareness-banner.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.jira-standard-automation-limit-awareness-banner.message": [
    {
      "type": 0,
      "value": "You're nearing or at your monthly automation run limit. Automations will fail to run this month if you hit the limit."
    }
  ]
}